import * as swcHelpers from '@swc/helpers';

const getLineItemAvailability = (availability)=>{
    if (!(availability === null || availability === void 0 ? void 0 : availability.channels)) {
        return undefined;
    }
    const channels = availability.channels.reduce((accumulator, currentValue)=>{
        return swcHelpers.objectSpread({}, accumulator, {
            [currentValue.key]: {
                isOnStock: currentValue.value.isOnStock,
                availableQuantity: currentValue.value.availableQuantity
            }
        });
    }, {});
    return {
        channels
    };
};

export { getLineItemAvailability };
//# sourceMappingURL=get-line-item-availability.js.map
